<template>
  <svg view-box="0 0 16 16" width="16px" height="16px">
    <image
      y="0"
      x="0"
      xlink:href="../../assets/WiresharkDoc-16.png"
      height="16"
      width="16"
    />
    <path
      style="
        fill: none;
        stroke: #888a85;
        stroke-width: 1px;
        stroke-linecap: butt;
        stroke-linejoin: miter;
        stroke-opacity: 1;
      "
      d="m 1.5,0.5 0,15 13,0 0,-11 -4,-4 z"
    />
  </svg>
</template>
